import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-03/lesson-21/task-02";

const task: Slide = {
  title: "Select all stable configurations of head and loudspeaker setups.",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
